import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { reducers } from "./state";
import { QuoteEffects } from "./effects/quote.effects";
import { CustomerEffects } from "./effects/customer.effects";
import { ProductEffects } from "./effects/product.effects";
import { RentalEffects } from "./effects/rental.effects";
import { PurchaseEffects } from "./effects/purchase.effects";
import { TransportEffects } from "./effects/transport.effects";
import { FloorPlannerEffects } from "./effects/floorplanner.effects";
import { KwikspaceEffects } from "./effects/kwikspace.effects";

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('kwikspaceApp', reducers),
    EffectsModule.forFeature([
      QuoteEffects,
      CustomerEffects,
      ProductEffects,
      RentalEffects,
      PurchaseEffects,
      TransportEffects,
      FloorPlannerEffects,
      KwikspaceEffects
    ]),
  ],
})
export class KwikspaceAppStoreModule { }
